import React, { useEffect, useState } from 'react';
import { useGetAllToolsQuery } from '../tools.service';
import ToolsList from '../ToolsList';
import { ToolType } from '../tools.types';
import useDocumentTitle from '../../../hooks/useDocumentTitle';

const ToolsTab = () => {
  const [maxPages, setMaxPages] = useState(0);
  const [page, setPage] = useState(0);
  const [scrollTools, setScrollTools] = useState<ToolType[]>([]);
  const size = 20;
  const { data, isLoading } = useGetAllToolsQuery({ page, size });
  useDocumentTitle('Tools');
  useEffect(() => {
    if (data) {
      setMaxPages(Math.ceil(data.countAll / size));
    }
  }, [data]);
  return (
    <ToolsList
      isLoading={isLoading}
      tools={data?.tools}
      setScrollTools={setScrollTools}
      scrollTools={scrollTools}
      page={page}
      setPage={setPage}
      maxPages={maxPages}
    />
  );
};

export default ToolsTab;
